import { IBusinessToolSessionStore, IBusinessToolStore } from './types';

export const getBusinessPlan = (state: IBusinessToolStore) => state.businessPlan;
export const getSetBusinessPlan = (state: IBusinessToolStore) => state.setBusinessPlan;

export const getActiveSection = (state: IBusinessToolStore) => state.activeSection;
export const getSetActiveSection = (state: IBusinessToolStore) => state.setActiveSection;

export const getActiveSubSection = (state: IBusinessToolStore) => state.activeSubSection;
export const getSetActiveSubSection = (state: IBusinessToolStore) => state.setActiveSubSection;

export const getBusinessPlanChapters = (store: IBusinessToolStore) => store.businessPlanChapters;
export const getSetBusinessPlanChapter = (store: IBusinessToolStore) => store.setBusinessPlanChapter;
export const getSetBusinessPlanChapters = (store: IBusinessToolStore) => store.setBusinessPlanChapters;
export const getBusinessToolChapterSelector = (store: IBusinessToolStore) => store.getBusinessToolChapter;

export const getBusinessToolTitle = (state: IBusinessToolStore) => state.businessPlanTitle;
export const getIsFirstTryToSetBusinessToolTitle = (state: IBusinessToolStore) =>
  state.isFirstTryToSetBusinessToolTitle;
export const getSetBusinessToolTitle = (state: IBusinessToolStore) => state.setBusinessPlanTitle;

export const getBusinessPlanType = (state: IBusinessToolStore) => state.businessPlanType;
export const getSetBusinessPlanType = (state: IBusinessToolStore) => state.setBusinessPlanType;

export const getBusinessPlanRequiredFieldsSelector = (state: IBusinessToolStore) => state.getBusinessPlanRequiredFields;

export const getBusinessPlanFocusedField = (state: IBusinessToolStore) => state.businessPlanFocusedField;
export const getSetBusinessPlanFocusedField = (state: IBusinessToolStore) => state.setBusinessPlanFocusedField;

export const getIsOpenFullScreenTable = (state: IBusinessToolStore) => state.isOpenFullScreenTable;
export const getSetIsOpenFullScreenTable = (state: IBusinessToolStore) => state.setisOpenFullScreenTable;

export const getBusinessPlanFocusedFieldId = (state: IBusinessToolStore) => state.businessPlanFocusedFieldId;
export const getSetBusinessPlanFocusedFieldId = (state: IBusinessToolStore) => state.setBusinessPlanFocusedFieldId;

export const getBusinessPlanFocusedFieldAttribute = (state: IBusinessToolStore) =>
  state.businessPlanFocusedFieldAttribute;
export const getSetBusinessPlanFocusedFieldAttribute = (state: IBusinessToolStore) =>
  state.setBusinessPlanFocusedFieldAttribute;

export const getAIAssistantReadinessPercent = (state: IBusinessToolStore) => state.AIAssistantReadinessPercent;
export const getSetAIAssistantReadinessPercent = (state: IBusinessToolStore) => state.setAIAssistantReadinessPercent;

export const getBusinessToolStoreClear = (state: IBusinessToolStore) => state.businessToolStoreClear;

export const getBusinessPlanMetadata = (state: IBusinessToolStore) => state.businessPlan.metadata;

export const getBusinessToolMode = (state: IBusinessToolSessionStore) => state.businessToolMode;
export const getSetBusinessToolMode = (state: IBusinessToolSessionStore) => state.setBusinessToolMode;

export const getOnePageDisplayMode = (state: IBusinessToolSessionStore) => state.onePageDisplayMode;
export const getSetOnePageDisplayMode = (state: IBusinessToolSessionStore) => state.setOnePageDisplayMode;

export const getBusinessPlanCurrency = (state: IBusinessToolStore) => state.businessPlanChapters.GLOBAL.currency;
